
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const Datenschutz = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-2xl font-bold mb-6 text-chrona-text">Datenschutzerklärung</h1>
      
      <Card className="border-chrona-gray-800 bg-chrona-gray-900/60 mb-6">
        <CardHeader className="border-b border-chrona-gray-800">
          <CardTitle className="text-chrona-text">1. Datenschutz auf einen Blick</CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="space-y-4 text-chrona-gray-300">
            <h3 className="text-lg font-medium text-chrona-text">Allgemeine Hinweise</h3>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, 
              wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert 
              werden können.
            </p>
            
            <h3 className="text-lg font-medium text-chrona-text">Datenerfassung auf unserer Website</h3>
            <p>
              <strong className="text-chrona-text">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem 
              Impressum dieser Website entnehmen.
            </p>
            
            <p>
              <strong className="text-chrona-text">Wie erfassen wir Ihre Daten?</strong><br />
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, 
              die Sie in ein Kontaktformular eingeben.
            </p>
            <p>
              Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische 
              Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, 
              sobald Sie unsere Website betreten.
            </p>
            
            <h3 className="text-lg font-medium text-chrona-text">Wofür nutzen wir Ihre Daten?</h3>
            <p>
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können 
              zur Analyse Ihres Nutzerverhaltens verwendet werden.
            </p>
            
            <h3 className="text-lg font-medium text-chrona-text">Welche Rechte haben Sie bezüglich Ihrer Daten?</h3>
            <p>
              Sie haben jederzeit das Recht unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten 
              personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung, Sperrung oder Löschung dieser Daten 
              zu verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter der im Impressum 
              angegebenen Adresse an uns wenden. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
            </p>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-chrona-gray-800 bg-chrona-gray-900/60 mb-6">
        <CardHeader className="border-b border-chrona-gray-800">
          <CardTitle className="text-chrona-text">2. Buchungsdaten & Speicherung</CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="space-y-4 text-chrona-gray-300">
            <p>
              Bei einer Buchung über CHRONA erheben wir folgende personenbezogene Daten, die für die Abwicklung Ihrer 
              Buchung notwendig sind:
            </p>
            
            <ul className="list-disc pl-5 space-y-2">
              <li>Name</li>
              <li>E-Mail-Adresse</li>
              <li>Telefonnummer (optional)</li>
              <li>Gebuchte Dienstleistungen und Zeitpunkte</li>
              <li>Ggf. zusätzliche Angaben, die Sie im Rahmen der Buchung machen</li>
            </ul>
            
            <p>
              Diese Daten werden zur Abwicklung Ihres Termins an den jeweiligen Dienstleister übermittelt und gemäß der 
              gesetzlichen Aufbewahrungsfristen gespeichert. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO.
            </p>
            
            <h3 className="text-lg font-medium text-chrona-text">Löschung Ihrer Daten</h3>
            <p>
              Sie haben jederzeit das Recht, Ihre Daten löschen zu lassen. Dazu können Sie entweder die Funktion "Konto löschen" 
              in Ihren Profileinstellungen nutzen oder uns direkt kontaktieren.
            </p>
            
            <p>
              Bitte beachten Sie, dass bestimmte Daten aufgrund gesetzlicher Aufbewahrungspflichten (z.B. für steuerrelevante Daten) 
              erst nach Ablauf dieser Fristen gelöscht werden können.
            </p>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-chrona-gray-800 bg-chrona-gray-900/60">
        <CardHeader className="border-b border-chrona-gray-800">
          <CardTitle className="text-chrona-text">3. Cookies & Analysedienste</CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="space-y-4 text-chrona-gray-300">
            <h3 className="text-lg font-medium text-chrona-text">Cookies</h3>
            <p>
              Die Internetseiten verwenden teilweise sogenannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und 
              enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. 
              Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.
            </p>
            
            <p>
              Die meisten der von uns verwendeten Cookies sind so genannte "Session-Cookies". Sie werden nach Ende Ihres Besuchs 
              automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert bis Sie diese löschen. Diese Cookies 
              ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.
            </p>
            
            <p>
              Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im 
              Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische 
              Löschen der Cookies beim Schließen des Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität 
              dieser Website eingeschränkt sein.
            </p>
            
            <h3 className="text-lg font-medium text-chrona-text">Analysedienste</h3>
            <p>
              Diese Website nutzt Funktionen des Webanalysedienstes Plausible Analytics. Anbieter ist Plausible Analytics, ein 
              datenschutzfreundlicher Dienst, der keine Cookies setzt und vollständig DSGVO-konform ist. Die Analyse erfolgt 
              auf Basis anonymisierter Daten.
            </p>
          </div>
        </CardContent>
      </Card>
      
      <div className="mt-8 text-center text-chrona-gray-400">
        <p>
          Stand: Mai 2025 - Bei Fragen zum Datenschutz kontaktieren Sie uns bitte unter: datenschutz@chrona-app.com
        </p>
      </div>
    </div>
  );
};

export default Datenschutz;
